var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerLevelsList",
      "extra-items": [{
        text: _vm.customerLevel.name,
        to: 'CustomerLevelsView',
        params: {
          id: this.$route.params.id
        }
      }, {
        text: '會員等級列表',
        to: 'CustomerLevelsCustomerList',
        params: {
          id: this.$route.params.id
        }
      }, '會員異動歷程']
    }
  })], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isFetching
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("會員異動歷程")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.customer.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.customer.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        }), _vm._v(" " + _vm._s(_vm._f("hiddenString")(data.item.customer.name, 20)) + " ")], 1)], 1)];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "change": _vm.fetchCustomers
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }